
const roundDown = (number, e = 3) => Math.floor(number / Math.pow(10, e)) * Math.pow(10, e);

export default roundDown;

export const roundDownSmart = (number) => {
  if (number > 100000) return roundDown(number, 3);
  if (number > 1000) return roundDown(number, 2);
  if (number > 100) return roundDown(number, 1);
  if (number > 10) return roundDown(number, 0);
  return Math.floor(number);
};
